import { Button, HFlow, Theme } from 'bold-ui'
import { useErrorHandler } from 'components/error'
import { PageContent } from 'components/layout/PageContent'
import { confirm } from 'components/modals/confirm'
import { useCancelarAtendimentoMutation } from 'graphql/hooks.generated'
import React, { Dispatch, useCallback } from 'react'
import { useHistory } from 'react-router'

import { useLocalStyles } from '../atendimento-individual/AtendimentoIndividualView'

export interface AtendimentoFooterProps {
  atendimentoId: ID
  isAtendimentoOdonto?: boolean
  clearCache: Dispatch<void>
}

export function AtendimentoFooter(props: AtendimentoFooterProps) {
  const { atendimentoId, isAtendimentoOdonto, clearCache } = props
  const history = useHistory()
  const [cancelar] = useCancelarAtendimentoMutation()
  const handleRejection = useErrorHandler()
  const { classes } = useLocalStyles(createStyles) // o do bold retorna classes novas a todo render
  const tipoAtendString = isAtendimentoOdonto ? 'odontológico' : 'individual'

  const handleCancelar = useCallback(() => {
    confirm({
      title: `Deseja cancelar o atendimento ${tipoAtendString}?`,
      body: 'As alterações realizadas serão perdidas.',
      confirmLabel: 'Sim',
      cancelLabel: 'Não',
      onConfirm: () => {
        cancelar({ variables: { atendimentoId } })
          .then(() => {
            clearCache()
            history.push('/lista-atendimento')
          })
          .catch(handleRejection)
      },
    })()
  }, [atendimentoId, cancelar, clearCache, handleRejection, history, tipoAtendString])

  return (
    <div className={classes.actions}>
      <PageContent type='filled' fluid>
        <HFlow justifyContent='flex-end'>
          <Button kind='normal' onClick={handleCancelar}>
            Cancelar atendimento {tipoAtendString}
          </Button>
        </HFlow>
      </PageContent>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  actions: {
    borderTop: `1px solid ${theme.pallete.divider}`,
    height: '6.125rem',
  },
})
